// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2caBn","legacyBtn":"MutateMid_legacyBtn__K_J1y"};